// import React from "react";
// import { Layout,Row, Col, Typography, Button, List, Space } from "antd";
// import { CheckCircleOutlined  } from "@ant-design/icons";
// import bannerImage from "../../assets/anvayaa-crm.svg";
// import { useNavigate } from "react-router-dom";
// import ThreeStep from "./ThreeStep";
// import CustomHeader from "./landingHeader";


// const { Title, Text } = Typography;
// const { Footer, Content } = Layout;

// const HomePage = () => {
//   const navigate = useNavigate();
//   const handleLogin = () => {
//     navigate("/partnerlogin");
//   };
//   const handleJoinUs = () => {
//     navigate("/partnerRegistration");
//   };

//   return (
//     <Layout style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
//     <CustomHeader  />
//     <Content style={{ padding: '40px', paddingBottom: '0px', flex: 1 }}>
//       <Row gutter={[16, 16]}>
//         <Col xs={24} md={12}>
//           <div style={{ maxWidth: 600 }}>
//             <Title style={{ fontSize: '35px', fontWeight: 500 }}>
//               Welcome to{" "}
//               <span
//                 style={{
//                   backgroundColor: '#F7DCD9',
//                   borderRadius: '4px', 
//                   padding: '1px 10px',
//                 }}
//               >
//                 Anvayaa's
//               </span>{" "}
//               Partner Management System
//             </Title>
//             <Text
//               type="secondary"
//               style={{ display: 'block', marginTop: '10px' }}
//             >
//               Crafting a new way to manage your business.
//             </Text>
//             <List
//               style={{ marginTop: '10px' }}
//               dataSource={[
//                 {
//                   title: 'Track business',
//                   description:
//                     'Track sales, customers, and growth levers directly from your phone',
//                 },
//                 {
//                   title: 'Durability',
//                   description:
//                     'We enable you to get more revenue, new customers, and boost your brand visibility by providing insights to improve your business.',
//                 },
//                 {
//                   title: '24*7 Assistance',
//                   description:
//                     'Get expert assistance for all your doubts with our partner support program',
//                 },
//               ]}
//               renderItem={(item) => (
//                 <List.Item>
//                   <List.Item.Meta
//                     avatar={
//                       <CheckCircleOutlined
//                         style={{
//                           fontSize: '25px',
//                           color: 'white',
//                           backgroundColor: 'purple',
//                           borderRadius: '20px',
//                         }}
//                       />
//                     }
//                     title={<b>{item.title}</b>}
//                     description={item.description}
//                   />
//                 </List.Item>
//               )}
//             />
//             <Space style={{ marginTop: '30px' }}>
//               <Button
//                 type="primary"
//                 shape="round"
//                 size="large"
//                 className="button-color"
//                 style={{ backgroundColor: '#F79122' }}
//                 onClick={handleJoinUs}
//               >
//                 Join Us
//               </Button>
//               <Button
//                 shape="round"
//                 size="large"
//                 style={{ backgroundColor: '#9d2d81', color: 'white' }}
//                 onClick={handleLogin}
//               >
//                 Sign In
//               </Button>
//             </Space>
//           </div>
//         </Col>
//         <Col
//           xs={24}
//           md={12}
//           style={{
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//           }}
//         >
//           <img
//             src={bannerImage}
//             alt="Banner"
//             style={{ maxWidth: '35%', height: '30%', maxHeight: '250px' }}
//           />
//           <ThreeStep />

//         </Col>
//       </Row>
//     </Content>
//     <Footer style={{ textAlign: 'center', backgroundColor: 'white', padding: '5px', position: 'sticky', bottom: 0, zIndex: 1, width: '100%' }}>
//       ©{new Date().getFullYear()} Anvayaa Kincare Pvt. Ltd. All Rights Reserved
//     </Footer>
//   </Layout>

//   );
// };

// export default HomePage;
















import React from "react";
import { Layout, Row, Col, Typography, Button, List, Space, Card, Grid } from "antd";
import { CheckCircleFilled, ArrowRightOutlined, LoginOutlined } from "@ant-design/icons";
import { IconHome, IconCertificate, IconCheck, IconProps } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import bannerImage from "../../assets/anvayaa-crm.svg";

const { Title, Text } = Typography;
const { Footer, Content } = Layout;
const { useBreakpoint } = Grid;

interface StepProps {
  icon: React.ComponentType<IconProps>;
  title: string;
  description: string;
}

const CustomHeader: React.FC = () => {
  return (
    <Layout.Header
      style={{
        display: "flex",
        alignItems: "center",
        padding: "0 clamp(16px, 4vw, 40px)",
        height: 64,
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #f3f4f6",
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.03)",
        position: "sticky",
        top: 0,
        zIndex: 100,
        width: "100%",
      }}
    >
      <img
        src={bannerImage}
        alt="Anvayaa Logo"
        style={{ width: "120px", height: "auto", objectFit: "contain" }}
      />
    </Layout.Header>
  );
};

const StepCard: React.FC<StepProps & { index: number }> = ({ icon: Icon, title, description, index }) => {
  return (
    <Card
      bordered={false}
      style={{
        height: "100%",
        background: "#ffffff",
        borderRadius: "16px",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)",
        border: "1px solid #f3f4f6",
        position: "relative",
        overflow: "hidden",
      }}
      styles={{
        body: { padding: "24px" }
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "-10px",
          right: "-10px",
          fontSize: "72px",
          fontWeight: 900,
          color: "#fdf4ff",
          lineHeight: 1,
          userSelect: "none",
          zIndex: 0,
        }}
      >
        {index + 1}
      </div>
      <div style={{ position: "relative", zIndex: 1 }}>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "48px",
            height: "48px",
            borderRadius: "12px",
            background: "linear-gradient(135deg, rgba(157,45,129,0.1) 0%, rgba(247,145,34,0.1) 100%)",
            color: "#9d2d81",
            marginBottom: "16px",
          }}
        >
          <Icon size={26} stroke={2} />
        </div>
        <Title level={4} style={{ margin: "0 0 8px 0", fontWeight: 700, color: "#111827", fontSize: "16px" }}>
          {title}
        </Title>
        <Text style={{ color: "#4b5563", fontSize: "13.5px", lineHeight: "1.5" }}>
          {description}
        </Text>
      </div>
    </Card>
  );
};

const ThreeStep: React.FC = () => {
  const stepsData = [
    {
      icon: IconHome,
      title: "Register",
      description: "Start with providing your basic details and corporate service setup options.",
    },
    {
      icon: IconCertificate,
      title: "Set Up",
      description: "Upload your mandatory legal documentation securely to verify your profile.",
    },
    {
      icon: IconCheck,
      title: "Onboard",
      description: "Our compliance team reviews details and activates your partner portal infrastructure.",
    },
  ];

  return (
    <div style={{ width: "100%", marginTop: "40px" }}>
      <Title
        level={3}
        style={{
          fontSize: "20px",
          fontWeight: 800,
          textAlign: "center",
          marginBottom: "24px",
          color: "#111827",
          letterSpacing: "-0.01em",
        }}
      >
        Our 3-Step Approval Process
      </Title>
      <Row gutter={[16, 16]}>
        {stepsData?.map((item, index) => (
          <Col key={item?.title} xs={24} sm={8}>
            <StepCard {...item} index={index} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const screens = useBreakpoint();

  const handleLogin = () => navigate("/partnerlogin");
  const handleJoinUs = () => navigate("/partnerRegistration");

  const valueLevers = [
    {
      title: "Track Business Performance",
      description: "Monitor real-time sales metrics, customer profiles, and analytical growth triggers parameters directly from your administrative suite dashboard.",
    },
    {
      title: "Sustainable Revenue Scaling",
      description: "Acquire higher volume marketplace distribution pipelines, new demographic segments, and optimized visibility architectures using target audience insights.",
    },
    {
      title: "24/7 Priority Partner Assistance",
      description: "Access our round-the-clock enterprise level corporate resolution ecosystem managed by partner relations specialists.",
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh", display: "flex", flexDirection: "column", backgroundColor: "#f9fafb" }}>
      <CustomHeader />

      <Content
        style={{
          padding: "clamp(14px, 5vw, 24px) clamp(10px, 4vw, 20px)",
          flex: 1,
          display: "flex",
          alignItems: "center",
          margin: "0 auto",
          width: "100%",
        }}
      >
        <Row gutter={[18, 18]} align="middle">
          <Col xs={24} lg={12}>
            <div style={{ maxWidth: "680px" }}>
              <h3
                style={{
                  fontSize: "clamp(10px, 4.5vw, 18px)",
                  fontWeight: 800,
                  color: "#111827",
                  lineHeight: 1.15,
                  letterSpacing: "-0.03em",
                  marginBottom: "16px",
                }}
              >
                Welcome to{" "}
                <span
                  style={{
                    background: "linear-gradient(135deg, #9d2d81 0%, #f79122 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    fontSize: "clamp(10px, 4.5vw, 18px)",
                    fontWeight: 800,
                  }}
                >
                  Anvayaa's
                </span>{" "}
                Partner Management System
              </h3>

              <Text
                style={{
                  display: "block",
                  fontSize: "clamp(15px, 2.5vw, 17px)",
                  color: "#4b5563",
                  lineHeight: "1.6",
                  marginBottom: "28px",
                }}
              >
                An enterprise ecosystem engineered to accelerate integration, track transactional data pipelines, and unify operational transparency.
              </Text>

              <List
                itemLayout="horizontal"
                dataSource={valueLevers}
                split={false}
                renderItem={(item) => (
                  <List.Item style={{ padding: "12px 0", alignItems: "flex-start" }}>
                    <div style={{ marginRight: "16px", marginTop: "4px" }}>
                      <CheckCircleFilled style={{ fontSize: "20px", color: "#9d2d81" }} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Text style={{ display: "block", fontSize: "15px", fontWeight: 700, color: "#111827", marginBottom: "2px" }}>
                        {item.title}
                      </Text>
                      <Text style={{ fontSize: "13.5px", color: "#4b5563", lineHeight: "1.5" }}>
                        {item.description}
                      </Text>
                    </div>
                  </List.Item>
                )}
              />

              <Space size={16} style={{ marginTop: "16px", width: "100%", flexWrap: "wrap" }}>
                <Button
                  type="primary"
                  size="large"
                  onClick={handleJoinUs}
                  icon={<ArrowRightOutlined />}
                  style={{
                    height: "40px",
                    padding: "0 28px",
                    borderRadius: "10px",
                    backgroundColor: "#f79122",
                    border: "none",
                    fontWeight: 600,
                    fontSize: "15px",
                    boxShadow: "0 4px 14px rgba(247, 145, 34, 0.3)",
                    display: "inline-flex",
                    alignItems: "center",
                    flexDirection: "row-reverse",
                    gap: "8px",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e07d16")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#f79122")}
                >
                  Join Us
                </Button>
                <Button
                  size="large"
                  type="text"
                  onClick={handleLogin}
                  icon={<LoginOutlined />}
                  style={{
                    height: "40px",
                    padding: "0 28px",
                    borderRadius: "10px",
                    backgroundColor: "#ffffff",
                    color: "#ff7900",
                    borderColor: "#ff7900",
                    fontWeight: 600,
                    fontSize: "15px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#ff7900";
                    e.currentTarget.style.color = "#ffffff";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#ffffff";
                    e.currentTarget.style.color = "#9d2d81";
                  }}
                >
                  Sign In
                </Button>
              </Space>
            </div>
          </Col>

          <Col xs={24} lg={12} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div
              style={{
                width: "100%",
                background: "linear-gradient(145deg, #ffffff 0%, #f3f4f6 100%)",
                borderRadius: "24px",
                padding: "24px",
                boxShadow: "0 10px 30px -10px rgba(0,0,0,0.05), 0 1px 3px rgba(0,0,0,0.02)",
                border: "1px solid #f3f4f6",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                src={bannerImage}
                alt="Infrastructure Management Asset"
                style={{
                  width: "100%",
                  maxWidth: "230px",
                  height: "auto",
                  maxHeight: "170px",
                  objectFit: "contain",
                  marginBottom: "10px",
                  filter: "drop-shadow(0 10px 15px rgba(0,0,0,0.03))",
                }}
              />
              <ThreeStep />
            </div>
          </Col>
        </Row>
      </Content>

      <Footer
        style={{
          textAlign: "center",
          backgroundColor: "#ffffff",
          color: "#6b21a8",
          fontSize: "12px",
          fontWeight: 500,
          padding: "16px 24px",
          borderTop: "1px solid #f3f4f6",
          letterSpacing: "0.02em",
        }}
      >
        © {new Date().getFullYear()} Anvayaa Kincare Pvt. Ltd. All Rights Reserved.
      </Footer>
    </Layout>
  );
};

export default HomePage;